module.exports = __webpack_public_path__ + "img/overview-cll.54b4fead.png";